import Button from "../form-control/Button";
import Gif from "../../assets/videos/balloons.gif"
import { useNavigate } from "react-router-dom";

const RegistrationSuccess = (): JSX.Element => {

    const handleDone = () => {
        window.location.href = '/auth?tab=sign-in';
    };

    return (
        <div className="flex flex-col items-center justify-center space-y-5 p-10">
            <img src={Gif} className="w-72" alt="Registration successful" width={100} height={100} />

            <div className="text-center max-w-lg space-y-2">
                <h2 className="font-headings font-bold text-6xl">Thank you!</h2>
                <p>Your organization has been successfully registered.</p>
                <p>Our team is verifying your KYC. You&apos;ll receive an email with instructions to set up your password as soon as verification is complete.</p>
                <p className="text-sm text-gray-500">If we need any additional information, we&apos;ll reach out to you directly.</p>
            </div>

            <Button
                label="Done"
                onClick={handleDone}
                className="w-full max-w-md flex justify-center items-center py-3.5 px-4 border border-transparent rounded-lg text-base font-medium text-white bg-gradient-to-r from-gray-800 to-gray-700 hover:from-gray-900 hover:to-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-600 disabled:opacity-70 disabled:cursor-not-allowed transition-all duration-200 shadow-lg shadow-gray-500/20 hover:shadow-gray-500/30"
            />
        </div>
    );
};

export default RegistrationSuccess;
